<article class="message" [ngClass]="getStylingForMessage()" fxFlex>
  <div class="message-body" fxLayoutAlign="center center">
    <mat-icon class="mat-18">{{getIconForMessage()}}</mat-icon>
    {{messageText}}
    <ng-content></ng-content>
  </div>
</article>
